/* eslint-disable */
import React from 'react';
import './UndatierteSidebar.css';
import './Leader.css';

const UndatierteSidebar = ({ 
    assignments, 
    onDrop, 
    onDropWorker,
    isOpen, 
    onClose, 
    onToggle, 
    onAddUndated,
    onAssignmentClick,
    onAssignmentHover,
    onAssignmentHoverEnd,
    onExternalDragStart,
    onExternalDragEnd,
    interaction,
    setInteraction,
    onContextMenu,
    clipboard,
    isReadOnly = false
}) => {
    // Show assignments that have no date (parked)
    const movedAssignments = (assignments || []).filter(a => 
        !a.start_datetime && a.deleted_at === null
    );

    const handleDragOver = (e) => {
        if (isReadOnly) return;
        e.preventDefault();
        e.currentTarget.classList.add('drag-over');
        
        // Signal to hide calendar previews
        if (interaction && setInteraction && !interaction.isOverSidebar) {
            setInteraction(prev => ({ ...prev, isOverSidebar: true }));
        }
    };

    const handleDragLeave = (e) => {
        e.currentTarget.classList.remove('drag-over');
        
        // Signal to restore calendar previews
        if (interaction && setInteraction && interaction.isOverSidebar) {
            setInteraction(prev => ({ ...prev, isOverSidebar: false }));
        }
    };

    const handleLocalDrop = (e) => {
        if (isReadOnly) return;
        e.preventDefault();
        e.currentTarget.classList.remove('drag-over');
        
        // Reset sidebar hover state on drop
        if (interaction && setInteraction) {
            setInteraction(prev => prev ? { ...prev, isOverSidebar: false } : null);
        }
        try {
            const dataString = e.dataTransfer.getData('application/json');
            if (!dataString) return;
            const data = JSON.parse(dataString);
            
            if (data.type === 'assignment') {
                onDrop(data.assignment);
            } else if (data.type === 'worker' || data.type === 'vehicle' || data.type === 'kolonne') {
                onDropWorker && onDropWorker(data, null, null, true);
            }
        } catch (err) {
            console.error('Drop error in Undated Sidebar:', err);
        }
    };

    const handleItemDragOver = (e) => {
        if (isReadOnly) return;
        e.preventDefault();
        e.stopPropagation();
        e.currentTarget.classList.add('drag-over-item');
    };

    const handleItemDragLeave = (e) => {
        if (isReadOnly) return;
        e.stopPropagation();
        e.currentTarget.classList.remove('drag-over-item');
    };

    const handleItemDrop = (e, a) => {
        if (isReadOnly) return;
        e.preventDefault();
        e.stopPropagation();
        e.currentTarget.classList.remove('drag-over-item');
        
        try {
            const dataString = e.dataTransfer.getData('application/json');
            if (!dataString) return;
            const data = JSON.parse(dataString);
            
            if (data.type === 'worker' || data.type === 'vehicle' || data.type === 'kolonne') {
                onDropWorker && onDropWorker(data, null, a);
            }
        } catch (err) {
            console.error('Item drop error:', err);
        }
    };

    if (!isOpen) {
        return (
            <div 
                className="undatierte-sidebar collapsed" 
                title="Undatierte Einsätze öffnen" 
                onClick={onToggle}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleLocalDrop}
            >
                <button className="btn-sidebar-collapse expand-btn" onClick={(e) => { e.stopPropagation(); onToggle(); }}>←</button>
                <div className="sidebar-toggle-vertical">
                   <span>📋 UNDATIERT ({movedAssignments.length})</span>
                </div>
            </div>
        );
    }

    return (
        <div 
            className="undatierte-sidebar"
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleLocalDrop}
        >
            <div className="sidebar-header">
                <h3 className="sidebar-title">Undatierte Einsätze</h3>
                <button className="sidebar-close-btn" onClick={onClose} title="Schließen">→</button>
            </div>
            <div 
                className="undatierte-list"
                style={{ cursor: 'pointer' }}
                onContextMenu={(e) => {
                    // Only trigger for the empty area
                    const isListBackground = e.target.classList.contains('undatierte-list');
                    const isEmptyState = e.target.closest('.undatierte-empty-state');
                    
                    if (isListBackground || isEmptyState) {
                        onContextMenu(e, null);
                    }
                }}
                onClick={(e) => {
                    // Trigger if clicking on the list background or any part of the empty state
                    const isListBackground = e.target.classList.contains('undatierte-list');
                    const isEmptyState = e.target.closest('.undatierte-empty-state');
                    
                    if (isListBackground || isEmptyState) {
                        !isReadOnly && onAddUndated && onAddUndated();
                    }
                }}
            >
                {movedAssignments.length === 0 ? (
                    <div className="undatierte-empty-state">
                        <div className="empty-icon">📅</div>
                        <p>Keine undatierten Einsätze</p>
                        <span>Hier landen Einträge, denen noch kein festes Datum zugewiesen wurde.</span>
                    </div>
                ) : (
                    movedAssignments.map(a => (
                        <div 
                            key={a.id} 
                            className={`undatierte-item status-${a.status || 'undatiert'}`} 
                            style={{ cursor: 'pointer' }}
                            onClick={() => onAssignmentClick(a)}
                            onMouseEnter={(e) => onAssignmentHover && onAssignmentHover(a, e)}
                            onMouseLeave={() => onAssignmentHoverEnd && onAssignmentHoverEnd()}
                            draggable={!isReadOnly}
                            onDragStart={(e) => {
                                if (isReadOnly) return;
                                e.dataTransfer.setData('application/json', JSON.stringify({ type: 'assignment', assignment: a }));
                                
                                // Set an empty/transparent drag image to avoid double visuals
                                const img = new Image();
                                img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
                                e.dataTransfer.setDragImage(img, 0, 0);

                                onExternalDragStart && onExternalDragStart(a);
                            }}
                            onDragEnd={() => {
                                onExternalDragEnd && onExternalDragEnd();
                            }}
                            onDragOver={handleItemDragOver}
                            onDragLeave={handleItemDragLeave}
                            onDrop={(e) => handleItemDrop(e, a)}
                            onContextMenu={(e) => {
                                e.stopPropagation();
                                onContextMenu(e, a);
                            }}
                        >
                            <div className="undatierte-item-header">
                                <span className="undatierte-item-title">{a.project_name}</span>
                                <span className={`undatierte-item-badge status-${a.status || 'undatiert'}`}>
                                    {a.status === 'aktiv' ? 'Aktiv' : 
                                     a.status === 'pausiert' ? 'Pausiert' : 
                                     a.status === 'abgeschlossen' ? 'Abgeschlossen' : 
                                     a.status === 'undatiert' ? 'Undatiert' : (a.status || 'Aktiv')}
                                </span>
                            </div>
                            {(a.workers?.length > 0 || a.vehicles?.length > 0) && (
                                <div className="undatierte-item-stats" style={{ marginTop: '4px' }}>
                                    <div className="assignment-resource-stats">
                                        {a.workers?.length > 0 && <span title={`${a.workers.length} Mitarbeiter`}>👤 {a.workers.length}</span>}
                                        {a.vehicles?.length > 0 && <span title={`${a.vehicles.length} Fahrzeuge`}>🚚 {a.vehicles.length}</span>}
                                    </div>
                                </div>
                            )}
                            {a.notes && <div className="undatierte-item-notes">{a.notes}</div>}
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default UndatierteSidebar;
